import { createModule } from '@vue-storefront/core/lib/module'
import { afterRegistration } from './hooks/afterRegistration'

export const KEY = 'DatadogLogging'

export const DatadogLogging = createModule({
  key: KEY,
  afterRegistration
})
